import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { YMMDProductsData } from "@store/Pages/ProductListYmmdPage";
import { getYMMD } from "@store/Services/YMMDService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";

interface YMMDProductsResults {
    availableDimensions: string[];
    products: YMMDProductsData[];
    fitments: [];
}

export interface YMMDProductsResultsModel {
    result: YMMDProductsResults;
}

export interface GetYMMDApiParameter {
    key?: string;
    year?: string;
    make?: string;
    model?: string;
    diameter?: string;
}

interface Props extends StoreHandlerProps {
    apiParameter: GetYMMDApiParameter;
}

type HandlerType = Handler<GetYMMDApiParameter, Props>;

export const DispatchBeginLoadProductsYMMD: HandlerType = props => {
    props.dispatch({
        type: "Components/RsswYMMD/BeginLoadProductsYMMD",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const GetProductsYMMD: HandlerType = async props => {
    const results = await getYMMD(props.apiParameter);

    props.dispatch({
        type: "Components/RsswYMMD/SetProducts",
        apiResult: results,
    });
};

export const chain = [
    DispatchBeginLoadProductsYMMD,
    PopulateApiParameter,
    GetProductsYMMD,
];

const getProductsYMMD = createHandlerChainRunner(chain, "GetProductsYMMD");
export default getProductsYMMD;
